export const ATT_BLUE = "#00A8E0";
export const ATT_COBALT = "#0057B8";

export const ATT_LOGOS = {
  att: "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/5wi69tck_IMG_1955.png",
  dm: "https://customer-assets-jt897jd0.emergentagent.net/job_legacy-secure-12/artifacts/57o32f5f_NEW%20DM%20Logo.webp",
};

export const ATT_CATALOG = {
  phones: [
    { id: "iphone-18-pro-max", name: "iPhone 18 Pro Max", brand: "Apple", img: "/att/iphone-18-black.webp", retail: "$1,299.99", monthly: "$36.12/mo.", storage: ["256GB", "512GB", "1TB", "2TB"], promo: "As low as $5.56/mo. with eligible trade-in", colors: [["Black", "#232427"], ["Silver", "#E8E8E6"], ["Glacier Blue", "#BFD0DE"], ["Burgundy", "#5C2E36"]], colorImgs: { "Black": "/att/iphone-18-black.webp", "Silver": "/att/iphone-18-white.webp", "Glacier Blue": "/att/iphone-18-blue.webp", "Burgundy": "/att/iphone-18-wine.webp" } },
    { id: "iphone-18-pro", name: "iPhone 18 Pro", brand: "Apple", img: "/att/iphone-18-white.webp", retail: "$1,199.99", monthly: "$33.34/mo.", storage: ["256GB", "512GB", "1TB"], promo: "$0/mo. with eligible trade-in", colors: [["Silver", "#E8E8E6"], ["Black", "#232427"], ["Glacier Blue", "#BFD0DE"], ["Burgundy", "#5C2E36"]], colorImgs: { "Black": "/att/iphone-18-black.webp", "Silver": "/att/iphone-18-white.webp", "Glacier Blue": "/att/iphone-18-blue.webp", "Burgundy": "/att/iphone-18-wine.webp" } },
    { id: "iphone-17", name: "iPhone 17", brand: "Apple", img: "/att/iphone-17.png", retail: "$829.99", monthly: "$23.06/mo.", storage: ["256GB", "512GB"], promo: "Trade-in credits available", colors: [["Black", "#3C4042"], ["White", "#FAFAFA"], ["Mist Blue", "#B3CBD9"], ["Sage", "#A8B5A0"], ["Lavender", "#C9B8D8"]] },
    { id: "iphone-air", name: "iPhone Air", brand: "Apple", img: "/att/iphone-air.png", retail: "$999.99", monthly: "$27.78/mo.", storage: ["256GB", "512GB", "1TB"], promo: "The thinnest iPhone ever", colors: [["Space Black", "#2C2C2E"], ["Cloud White", "#F5F5F0"], ["Light Gold", "#E8DCC0"], ["Sky Blue", "#B8D4E8"]] },
    { id: "iphone-17e", name: "iPhone 17e", brand: "Apple", img: "/att/iphone-17e.png", retail: "$599.99", monthly: "$16.67/mo.", storage: ["128GB", "256GB", "512GB"], promo: "Most affordable new iPhone", colors: [["Black", "#3C4042"], ["White", "#FAFAFA"], ["Soft Pink", "#F2D4D7"]] },
    { id: "iphone-16", name: "iPhone 16", brand: "Apple", img: "/att/iphone-16.png", retail: "$729.99", monthly: "$20.28/mo.", storage: ["128GB", "256GB", "512GB"], noTradeIn: true, promo: "$0/mo. on new lines — no trade-in needed", colors: [["Black", "#3C4042"], ["Teal", "#B0D4D2"], ["Pink", "#F2ADDA"], ["White", "#FAFAFA"], ["Ultramarine", "#9AADF6"]] },
    { id: "iphone-16e", name: "iPhone 16e", brand: "Apple", img: "/att/iphone-16e.png", retail: "$599.99", monthly: "$16.67/mo.", storage: ["128GB", "256GB", "512GB"], noTradeIn: true, promo: "As low as $5.99/mo. — no trade-in needed", colors: [["Black", "#3C4042"], ["White", "#FAFAFA"]] },
    { id: "galaxy-s26-ultra", name: "Samsung Galaxy S26 Ultra", brand: "Samsung", img: "/att/galaxy-s26-ultra.png", retail: "$1,299.99", monthly: "$36.12/mo.", storage: ["256GB", "512GB", "1TB"], promo: "Up to $1,000 off with trade-in", colors: [["Black", "#494D53"], ["Cobalt Violet", "#686884"], ["Sky Blue", "#B3CBD9"], ["White", "#F3F4F5"]] },
    { id: "galaxy-s26", name: "Samsung Galaxy S26", brand: "Samsung", img: "/att/galaxy-s26.png", retail: "$899.99", monthly: "$25.00/mo.", storage: ["128GB", "256GB", "512GB"], noTradeIn: true, promo: "$0/mo. on new lines — no trade-in needed", colors: [["Black", "#494D53"], ["Cobalt Violet", "#686884"], ["Sky Blue", "#B3CBD9"], ["White", "#F3F4F5"]] },
    { id: "galaxy-s25", name: "Samsung Galaxy S25", brand: "Samsung", img: "/att/galaxy-s25.png", retail: "$799.99", monthly: "$22.23/mo.", storage: ["128GB", "256GB"], noTradeIn: true, promo: "$0/mo. on new lines — no trade-in needed", colors: [["Navy", "#3B4B6B"], ["Icy Blue", "#BFD7E4"], ["Mint", "#C9E4D2"], ["Silver Shadow", "#C8CBD0"]] },
    { id: "galaxy-s25-fe", name: "Samsung Galaxy S25 FE", brand: "Samsung", img: "/att/galaxy-s25-fe.png", retail: "$649.99", monthly: "$18.06/mo.", storage: ["128GB", "256GB", "512GB"], noTradeIn: true, promo: "As low as $2.99/mo. — no trade-in needed", colors: [["Jet Black", "#1D1D1F"], ["Navy", "#3B4B6B"], ["Icy Blue", "#BFD7E4"], ["White", "#FAFAFA"]] },
    { id: "galaxy-z-fold8", name: "Samsung Galaxy Z Fold8 Ultra", brand: "Samsung", img: "/att/galaxy-z-fold8.png", retail: "$1,999.99", monthly: "$55.56/mo.", storage: ["256GB", "512GB", "1TB"], promo: "Trade-in any year, any condition", colors: [["Cream", "#EDE6D6"], ["Graphite", "#54565B"], ["Violet Shadow", "#6E6480"]] },
    { id: "pixel-11-pro", name: "Google Pixel 11 Pro", brand: "Google", img: "/att/pixel-11-pro.png", retail: "$1,149.99", monthly: "$31.95/mo.", storage: ["128GB", "256GB", "512GB", "1TB"], promo: "$0/mo. with eligible trade-in", colors: [["Obsidian", "#3A3F3E"], ["Canyon", "#F6A593"]] },
    { id: "moto-razr-plus", name: "Motorola Razr+ (2026)", brand: "Motorola", img: "/att/moto-razr-plus.png", retail: "$999.99", monthly: "$27.78/mo.", storage: ["256GB", "512GB"], promo: "$0/mo. with eligible trade-in", colors: [["Mountain View", "#6E7B6B"], ["Pantone Black", "#1D1D1F"]] },
    { id: "moto-razr-ultra", name: "Motorola Razr Ultra", brand: "Motorola", img: "/att/moto-razr-ultra.png", retail: "$1,299.99", monthly: "$36.12/mo.", storage: ["512GB", "1TB"], promo: "Trade-in any year, any condition", colors: [["Rio Red", "#A93B45"], ["Scarab", "#3A3F3E"]] },
    { id: "moto-edge", name: "Motorola Edge (2026)", brand: "Motorola", img: "/att/moto-edge.png", retail: "$549.99", monthly: "$15.28/mo.", storage: ["256GB"], noTradeIn: true, promo: "As low as $0.99/mo. — no trade-in needed", colors: [["Martini Olive", "#7A7A5C"]] },
    { id: "moto-g-stylus", name: "Moto G Stylus 5G", brand: "Motorola", img: "/att/moto-g-stylus.png", retail: "$399.99", monthly: "$11.12/mo.", storage: ["128GB", "256GB"], noTradeIn: true, promo: "$0/mo. on new lines — no trade-in needed", colors: [["Gibraltar Sea", "#3B4A5A"]] },
  ],
  tablets: [
    { id: "ipad-pro-m5", name: "iPad Pro 11\" (M5)", brand: "Apple", img: "/att/ipad-pro-m5.png", retail: "$999.99", monthly: "$27.78/mo.", storage: ["256GB", "512GB", "1TB", "2TB"], promo: "Pro power with the new M5 chip", colors: [["Space Black", "#2C2C2E"], ["Silver", "#E5E5E5"]] },
    { id: "ipad-air-m4", name: "iPad Air 11\" (M4)", brand: "Apple", img: "/att/ipad-air-m4.png", retail: "$599.99", monthly: "$16.67/mo.", storage: ["128GB", "256GB", "512GB", "1TB"], promo: "Add to any plan for $10/mo.", colors: [["Blue", "#9AB4C8"], ["Purple", "#C9B8D8"], ["Space Gray", "#54565B"], ["Starlight", "#F0E9DD"]] },
    { id: "ipad-a16", name: "iPad (A16)", brand: "Apple", img: "/att/ipad-a16.png", retail: "$349.99", monthly: "$9.73/mo.", storage: ["128GB", "256GB", "512GB"], promo: "The family-favorite iPad", colors: [["Blue", "#9AB4C8"], ["Pink", "#F2ADDA"], ["Silver", "#E5E5E5"], ["Yellow", "#F2E29B"]] },
    { id: "tab-a11", name: "Samsung Galaxy Tab A11+ 5G", brand: "Samsung", img: "/att/tab-a11.png", retail: "$279.99", monthly: "$7.78/mo.", storage: ["64GB", "128GB"], promo: "Budget-friendly 5G tablet", colors: [["Gray", "#8A8D91"]] },
  ],
  watches: [
    { id: "watch-ultra-3", name: "Apple Watch Ultra 3", brand: "Apple", img: "/att/watch-ultra-3.png", retail: "$799.99", monthly: "$22.23/mo.", storage: ["49mm · GPS + Cellular"], promo: "Rugged titanium. Built for adventure.", colors: [["Black Titanium", "#2C2C2E"], ["Natural Titanium", "#C8C2B8"]] },
    { id: "watch-series-11", name: "Apple Watch Series 11", brand: "Apple", img: "/att/watch-series-11.png", retail: "$399.99", monthly: "$11.12/mo.", storage: ["42mm", "46mm"], promo: "Add to your plan for $10/mo.", colors: [["Jet Black", "#1D1D1F"], ["Rose Gold", "#E8C4BC"], ["Silver", "#E5E5E5"], ["Space Gray", "#54565B"]] },
    { id: "watch-se-3", name: "Apple Watch SE 3", brand: "Apple", img: "/att/watch-se-3.png", retail: "$249.99", monthly: "$6.95/mo.", storage: ["40mm", "44mm"], promo: "Essential features. Great price.", colors: [["Midnight", "#1D2532"], ["Starlight", "#F0E9DD"]] },
    { id: "galaxy-watch8", name: "Samsung Galaxy Watch8", brand: "Samsung", img: "/att/galaxy-watch8.png", retail: "$349.99", monthly: "$9.73/mo.", storage: ["40mm", "44mm"], promo: "Perfect Galaxy companion", colors: [["Graphite", "#54565B"], ["Silver", "#E5E5E5"]] },
  ],
  accessories: [],
};

export const ATT_DEVICES = {
  phones: ATT_CATALOG.phones.map((d) => d.name),
  tablets: ATT_CATALOG.tablets.map((d) => d.name),
  watches: ATT_CATALOG.watches.map((d) => d.name),
};

export const ATT_SERVICES = {
  residential: [
    {
      id: "wireless",
      name: "AT&T Wireless",
      blurb: "Unlimited talk, text & data on America's most reliable 5G network.",
      details: [
        "Unlimited plans starting at $35.99/mo. per line (4 lines, Value Plus VL)",
        "5G access included on every unlimited plan",
        "AT&T ActiveArmor security built in at no extra cost",
        "Mexico, Canada & Latin America usage included on select plans",
        "Same-day number transfers from any carrier",
      ],
    },
    {
      id: "fiber",
      name: "AT&T Fiber Home Internet",
      blurb: "Ultra-fast, symmetrical fiber internet with no data caps and no annual contract.",
      details: [
        "Speeds from 300 Mbps up to 5 GIG",
        "Equal upload & download speeds — perfect for streaming, gaming & work-from-home",
        "No data caps, no annual contract, no equipment fee",
        "AT&T Smart Wi-Fi with whole-home coverage",
        "Save $20/mo. when you bundle fiber with an eligible wireless plan",
      ],
    },
    {
      id: "internet-air",
      name: "AT&T Internet Air",
      blurb: "Wireless home internet powered by the AT&T 5G network — plug in and go.",
      details: [
        "Simple self-setup in under 15 minutes — no technician needed",
        "Great for areas where fiber isn't available yet",
        "All-in monthly pricing with AT&T All-Fi Hub included",
        "No annual contract and no data caps",
      ],
    },
  ],
  business: [
    {
      id: "business-wireless",
      name: "AT&T Business Wireless",
      blurb: "Unlimited business plans that keep your team connected anywhere.",
      details: [
        "Business Unlimited Advanced 3.0 — $25/mo. per line when you get 4 lines",
        "5G access, hotspot data, and ActiveArmor security included",
        "Pool lines across your whole team with flexible add-ons",
        "Dedicated business support",
      ],
    },
    {
      id: "business-fiber",
      name: "AT&T Business Fiber",
      blurb: "Dedicated, symmetrical fiber built for business — with reward card offers.",
      details: [
        "Speeds from 300 Mbps to 5 GIG for your business location",
        "Get a $300–$500 AT&T Visa Reward Card by speed tier (online orders)",
        "Free installation when you order online",
        "AT&T covers early termination fees from your old provider — up to $750",
        "99.9% reliability with 24/7 business-class support",
      ],
    },
    {
      id: "business-devices",
      name: "Business Devices & Fleet",
      blurb: "Equip your team with phones, tablets, and wearables on one account.",
      details: [
        "Volume device ordering for teams of any size",
        "Trade in your team's old devices for monthly bill credits",
        "Tablets for field work, watches for on-the-go staff",
        "One invoice, one point of contact — us",
      ],
    },
  ],
};

export const ATT_PROMOS = {
  residential: [
    { title: "iPhone 18 Pro on us", desc: "Get iPhone 18 Pro for $0 with an eligible trade-in (value $290+) on a qualifying unlimited plan. Credits applied monthly over 36 months." },
    { title: "Up to $830 in trade-in credits", desc: "Trade-ins valued $130–$289 earn up to $830 in credits; devices valued $35–$129 earn up to $350." },
    { title: "Switch & get up to $800 per line", desc: "Break your contract — get up to $800 per line via reward card to pay off your old phone balance, up to 10 lines." },
    { title: "$0 phones — no trade-in needed", desc: "iPhone 16, iPhone 16e, Galaxy S25, S25 FE, Galaxy S26, Motorola Edge and Moto G Stylus are $0/mo. or deeply discounted on new lines — no trade-in required." },
    { title: "$20/mo. bundle savings", desc: "Save $20 every month on AT&T Fiber when you bundle with an eligible unlimited wireless plan." },
    { title: "Free fiber installation", desc: "Order AT&T Fiber online through us and installation is free." },
    { title: "$0 phones on new lines", desc: "Select phones like iPhone 16 and Galaxy S26 are $0/mo. on new lines — no trade-in required." },
  ],
  business: [
    { title: "$25/line Business Unlimited", desc: "Business Unlimited Advanced 3.0 for just $25/mo. per line when you get 4 lines." },
    { title: "Up to $500 Visa Reward Card", desc: "New Business Fiber customers: $300 for Fiber 300, $400 for Fiber 500, $500 for 1 GIG or higher (limited time)." },
    { title: "We cover your switch — up to $750", desc: "AT&T covers early termination fees from your previous internet provider, up to $750." },
    { title: "Free install on online orders", desc: "Business Fiber installation is free when your order is placed online with us." },
    { title: "Volume trade-in credits", desc: "Trade in your team's old devices — any year, any condition on select models — for monthly bill credits." },
    { title: "No trade-in business deals", desc: "Equip your team with iPhone 16, 16e, Galaxy S25, S25 FE, S26, Motorola Edge, and Moto G Stylus on new lines — no trade-in required, volume pricing available." },
    { title: "Up to 20 lines, one invoice", desc: "Pool up to 20 lines with phones, tablets, and watches on a single business account we manage for you." },
  ],
};

export const ATT_PLAN_DETAILS = {
  residential: [
    { name: "AT&T Unlimited Premium PL", price: "$85.99/mo.", per: "1 line — as low as $50.99/line for 4 lines", features: ["Unlimited premium data — never slowed", "60GB hotspot data per line", "4K UHD streaming available", "Best deals on new phones"] },
    { name: "AT&T Unlimited Extra EL", price: "$75.99/mo.", per: "1 line — as low as $40.99/line for 4 lines", features: ["75GB premium data per line", "30GB hotspot data per line", "5G access included", "ActiveArmor security"] },
    { name: "AT&T Unlimited Starter SL", price: "$65.99/mo.", per: "1 line — as low as $35.99/line for 4 lines", features: ["Unlimited talk, text & data", "5G access included", "Mexico & Canada usage included", "Great everyday value"] },
    { name: "AT&T Value Plus VL", price: "$50.99/mo.", per: "1 line — as low as $35.99/line for 4 lines", features: ["Our lowest-priced unlimited plan", "5G access included", "Unlimited talk & text", "No annual contract"] },
  ],
  business: [
    { name: "Business Unlimited Advanced 3.0", price: "$25/line/mo.", per: "when you get 4 lines", features: ["Unlimited data, talk & text", "60GB hotspot per line", "5G+ access included", "ActiveArmor business security"] },
    { name: "Business Unlimited Performance", price: "$35/line/mo.", per: "when you get 4 lines", features: ["Premium unlimited data", "100GB hotspot per line", "4K UHD streaming", "Priority network access"] },
    { name: "Business Unlimited Standard", price: "$30/line/mo.", per: "when you get 4 lines", features: ["Unlimited data, talk & text", "30GB hotspot per line", "5G access included", "Dedicated business support"] },
  ],
};

export const ATT_INTERNET = {
  residential: [
    { name: "AT&T Fiber 300", speed: "300 Mbps", price: "$55/mo.", desc: "Great for streaming, browsing, and video calls in smaller households." },
    { name: "AT&T Fiber 500", speed: "500 Mbps", price: "$65/mo.", desc: "Room for the whole family to stream, game, and work at once." },
    { name: "AT&T Fiber 1 GIG", speed: "1,000 Mbps", price: "$80/mo.", desc: "Our most popular speed — heavy streaming, gaming, and smart homes." },
    { name: "AT&T Fiber 2 GIG", speed: "2,000 Mbps", price: "$145/mo.", desc: "Serious speed for creators, large households, and power users." },
    { name: "AT&T Fiber 5 GIG", speed: "5,000 Mbps", price: "$245/mo.", desc: "The fastest residential internet AT&T offers. No compromises." },
    { name: "AT&T Internet Air", speed: "5G Wireless", price: "$60/mo.", desc: "Plug-and-play 5G home internet — $47/mo. with an eligible wireless plan." },
  ],
  business: [
    { name: "Business Fiber 300", speed: "300 Mbps", price: "$70/mo.", desc: "Reliable symmetrical speed for small offices — $300 reward card offer." },
    { name: "Business Fiber 500", speed: "500 Mbps", price: "$95/mo.", desc: "Growing teams, cloud apps, and VoIP — $400 reward card offer." },
    { name: "Business Fiber 1 GIG", speed: "1,000 Mbps", price: "$110/mo.", desc: "Full-speed operations for demanding businesses — $500 reward card offer." },
    { name: "Business Fiber 2 GIG+", speed: "2–5 GIG", price: "Custom", desc: "Multi-location and bandwidth-heavy operations. We'll quote it for you." },
    { name: "Internet Air for Business", speed: "5G Wireless", price: "$60/mo.", desc: "Fast wireless backup or primary internet where fiber isn't available yet." },
  ],
};

export const ATT_PORTING_INFO =
  "Porting means keeping your current phone number when you switch to AT&T. If yes — don't cancel your old service until the transfer completes, and have your current account number and transfer PIN ready. Most number transfers complete the same day.";

export const ATT_PLANS = {
  residential: {
    wireless: [
      "AT&T Unlimited Premium PL",
      "AT&T Unlimited Extra EL",
      "AT&T Unlimited Starter SL",
      "AT&T Value Plus VL",
      "Not sure — help me choose",
    ],
    internet: [
      "AT&T Fiber 300 Mbps",
      "AT&T Fiber 500 Mbps",
      "AT&T Fiber 1 GIG",
      "AT&T Fiber 2 GIG",
      "AT&T Fiber 5 GIG",
      "AT&T Internet Air",
      "Not sure — help me choose",
    ],
  },
  business: {
    wireless: [
      "Business Unlimited Advanced 3.0",
      "Business Unlimited Performance",
      "Business Unlimited Standard",
      "Not sure — help me choose",
    ],
    internet: [
      "AT&T Business Fiber 300",
      "AT&T Business Fiber 500",
      "AT&T Business Fiber 1 GIG",
      "AT&T Business Fiber 2 GIG+",
      "AT&T Internet Air for Business",
      "Not sure — help me choose",
    ],
  },
};

export const ATT_REP_ROLES = [
  {
    id: "door-to-door",
    name: "Door to Door Sales Rep",
    desc: "Hit the neighborhoods where AT&T Fiber just landed. You'll knock doors, introduce families to faster internet and wireless savings, and earn uncapped commission on every sale. High energy, high reward — top D2D reps out-earn everyone.",
  },
  {
    id: "events",
    name: "Events Sales Rep",
    desc: "Represent AT&T at festivals, fairs, community events, and pop-up booths. You bring the personality, we bring the table, the tech, and the offers. Perfect for people who love crowds and conversation.",
  },
  {
    id: "national-retail",
    name: "National Retail Sales Rep",
    desc: "Work inside major national retail stores at the AT&T display. Help walk-in shoppers upgrade phones, switch carriers, and bundle internet — with steady foot traffic delivered to you every single day.",
  },
  {
    id: "business-sales",
    name: "Business Sales Rep",
    desc: "Sell AT&T to businesses — wireless fleets, business fiber, and multi-line accounts. You'll prospect local companies, build relationships with owners and office managers, and close bigger deals with bigger commissions. B2B experience is a plus, hustle is a must.",
  },
  {
    id: "work-from-home",
    name: "Work From Home Sales Rep",
    desc: "Sell AT&T services entirely from home — phone and online leads, virtual appointments, and follow-ups. Flexible schedule, no commute, full training and scripts provided. All you need is a quiet space and drive.",
  },
];

export const ATT_SHIRT_SIZES = ["Small", "Medium", "Large", "XL", "2XL", "3XL", "4XL", "5XL"];

export const ATT_TRADE_PHONES = {
  Apple: [
    "iPhone 17 Pro Max", "iPhone 17 Pro", "iPhone 17", "iPhone Air", "iPhone 17e",
    "iPhone 16 Pro Max", "iPhone 16 Pro", "iPhone 16 Plus", "iPhone 16", "iPhone 16e",
    "iPhone 15 Pro Max", "iPhone 15 Pro", "iPhone 15 Plus", "iPhone 15",
    "iPhone 14 Pro Max", "iPhone 14 Pro", "iPhone 14 Plus", "iPhone 14",
    "iPhone 13 Pro Max", "iPhone 13 Pro", "iPhone 13", "iPhone 13 mini",
    "iPhone 12 Pro Max", "iPhone 12 Pro", "iPhone 12", "iPhone 12 mini",
    "iPhone 11 Pro Max", "iPhone 11 Pro", "iPhone 11", "iPhone SE",
  ],
  Samsung: [
    "Galaxy S26 Ultra", "Galaxy S26+", "Galaxy S26",
    "Galaxy S25 Ultra", "Galaxy S25+", "Galaxy S25", "Galaxy S25 FE",
    "Galaxy S24 Ultra", "Galaxy S24+", "Galaxy S24", "Galaxy S24 FE",
    "Galaxy S23 Ultra", "Galaxy S23+", "Galaxy S23", "Galaxy S23 FE",
    "Galaxy S22 Ultra", "Galaxy S22+", "Galaxy S22",
    "Galaxy S21 Ultra", "Galaxy S21+", "Galaxy S21",
    "Galaxy Z Fold8", "Galaxy Z Fold7", "Galaxy Z Fold6",
    "Galaxy Z Flip7", "Galaxy Z Flip6", "Galaxy Z Flip5",
    "Galaxy Note 20 Ultra", "Galaxy Note 20", "Galaxy A series",
  ],
  Google: [
    "Pixel 11 Pro", "Pixel 11", "Pixel 10 Pro", "Pixel 10",
    "Pixel 9 Pro", "Pixel 9", "Pixel 8 Pro", "Pixel 8", "Pixel 7 Pro", "Pixel 7", "Pixel 6",
  ],
  Motorola: ["Motorola Razr+", "Motorola Razr", "Motorola Razr Ultra", "Motorola Edge", "Moto G series"],
  Other: ["OnePlus", "Nokia", "LG", "Other / not listed"],
};

export const ATT_TRADE_STORAGE = ["32GB", "64GB", "128GB", "256GB", "512GB", "1TB", "Not sure"];

export const ATT_TRADE_CONDITIONS = [
  "Like new — flawless",
  "Good — minor wear",
  "Fair — visible scratches or dents",
  "Cracked screen or back",
  "Doesn't power on",
];

export const parseMoney = (s) => parseFloat(String(s).replace(/[^0-9.]/g, "")) || 0;

export const ATT_ALL_DEVICES = [
  ...ATT_CATALOG.phones.map((d) => ({ ...d, category: "Phone" })),
  ...ATT_CATALOG.tablets.map((d) => ({ ...d, category: "Tablet" })),
  ...ATT_CATALOG.watches.map((d) => ({ ...d, category: "Watch" })),
];

export const findDevice = (id) => ATT_ALL_DEVICES.find((d) => d.id === id);

export const storagePrice = (device, idx) => {
  const base = parseMoney(device.retail);
  const label = (device.storage && device.storage[idx]) || "";
  const isSize = !/GB|TB/.test(label);
  const step = isSize ? 30 : base >= 900 ? 200 : 100;
  const offsets = [0, step, step * 2, step * 4];
  return base + (offsets[idx] || 0);
};

export const ATT_TRADE_PROMO_TIERS = [
  { id: "high", label: "High-value trade-in ($290+ value)", desc: "Newer flagships in good shape — up to $1,100 in bill credits over 36 months.", credit: 1100 },
  { id: "mid", label: "Mid-value trade-in ($130–$289 value)", desc: "Recent phones with normal wear — up to $830 in bill credits.", credit: 830 },
  { id: "low", label: "Lower-value trade-in ($35–$129 value)", desc: "Older or well-worn phones — up to $350 in bill credits.", credit: 350 },
  { id: "unsure", label: "Not sure — value my phone for me", desc: "We'll confirm your exact trade-in value and promo when we call.", credit: 0 },
];

export const ATT_NEXT_UP = {
  name: "AT&T Next Up Anytime",
  price: 10,
  desc: "Upgrade whenever you want — once you've paid off just one-third of your phone, trade it in and jump to a new one. $10/mo per device, cancel anytime.",
};

export const ATT_INSURANCE = [
  {
    id: "pa1",
    name: "AT&T Protect Advantage for 1",
    price: 14.99,
    desc: "Covers this device against loss, theft, and damage. Unlimited claims, unlimited $29 screen repairs, battery replacement, same-day device replacement, and 24/7 ProTech expert support.",
  },
  {
    id: "pa4",
    name: "AT&T Protect Advantage for 4",
    price: 45.0,
    desc: "Covers up to 4 devices on your account — loss, theft, and damage. Unlimited claims, unlimited $29 screen repairs, battery replacements, and ProTech support for the whole family.",
  },
  {
    id: "none",
    name: "No insurance",
    price: 0,
    desc: "Skip device protection for now — you can still add Protect Advantage within 30 days of activation.",
  },
];

export const ATT_CARRIERS = [
  "AT&T",
  "Verizon",
  "T-Mobile",
  "Metro by T-Mobile",
  "Cricket Wireless",
  "Boost Mobile",
  "Straight Talk",
  "Mint Mobile",
  "Visible",
  "US Cellular",
  "Xfinity Mobile",
  "Spectrum Mobile",
  "Google Fi",
  "TracFone",
  "Consumer Cellular",
  "Other",
];
